module.exports = __webpack_public_path__ + "static/media/LOADER_02.4b9b57c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_02.png
// module id = 310
// module chunks = 0